import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductScarcity extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateScarcity);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateScarcity);
  }

  updateScarcity = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newScarcity = event.detail.data.html.querySelector('product-scarcity');

    if (!newScarcity) return;

    morph(this, newScarcity, { childrenOnly: true });
  };
}

if (!customElements.get('product-scarcity')) {
  customElements.define('product-scarcity', ProductScarcity);
}
